import React, { type ComponentType } from 'react';
import {
	ModalTransition,
	ModalHeader,
	ModalBody,
	ModalTitle,
	ModalFooter,
} from '@atlaskit/modal-dialog';
import { JiraModal as ModalDialog } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type Props = {
	isDialogVisible: boolean;
	versionName: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Content: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Footer: ComponentType<any>;
	onClose: () => void;
} & Intl;

export function DeleteModal({
	Content,
	Footer,
	isDialogVisible,
	onClose,
	intl: { formatMessage },
	versionName,
}: Props): React.JSX.Element {
	return (
		<ModalTransition>
			{isDialogVisible && (
				<ShortcutScope>
					<ModalDialog
						messageId="version-modals.delete-version.modal-dialog"
						messageType="transactional"
						onClose={onClose}
					>
						<ModalHeader hasCloseButton={fg('enghealth-41206-modal-header-close-button')}>
							<ModalTitle appearance="warning">
								{formatMessage(messages.title, { name: versionName })}
							</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<ViewTracker />
							<Content />
						</ModalBody>
						<ModalFooter>
							<Footer />
						</ModalFooter>
					</ModalDialog>
				</ShortcutScope>
			)}
		</ModalTransition>
	);
}

export default AnalyticsSource('deleteVersion', MODAL)(injectIntl(DeleteModal));
